export default "__VITE_ASSET__uK8dDfZQ__"